import { render, staticRenderFns } from "./ProjectLoader.vue?vue&type=template&id=0ffd5de4&"
import script from "./ProjectLoader.vue?vue&type=script&lang=js&"
export * from "./ProjectLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLoader.vue?vue&type=style&index=0&id=0ffd5de4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports